import { Component, Input, OnInit } from "@angular/core";
import { NoticiasService } from "../../../servicios/noticias/noticias.service";
import { BloquePatrocinadosComponent } from "../../bloques-filas/bloque-patrocinados/bloque-patrocinados.component";
import { BloqueUltimosBlogsComponent } from "../../bloques-filas/bloque-ultimos-blogs/bloque-ultimos-blogs.component";
import { DosColumnasMultifilasComponent } from "../../bloques-filas/dos-columnas-multifilas/dos-columnas-multifilas.component";
import { FilaCuatroColumnasComponent } from "../../bloques-filas/fila-cuatro-columnas/fila-cuatro-columnas.component";
import { FilaTresColumnasComponent } from "../../bloques-filas/fila-tres-columnas/fila-tres-columnas.component";
import { FilaDosColumnasComponent } from "../../bloques-filas/fila-dos-columnas/fila-dos-columnas.component";
import { FilaUnaColumnaComponent } from "../../bloques-filas/fila-una-columna/fila-una-columna.component";
import { NgFor, NgSwitch, NgSwitchCase, NgClass } from "@angular/common";
import { first } from "rxjs";

@Component({
  selector: "app-estructura-seccion",
  templateUrl: "./estructura-seccion.component.html",
  styleUrls: ["./estructura-seccion.component.css"],
  imports: [NgFor, NgSwitch, NgSwitchCase, NgClass, FilaUnaColumnaComponent, FilaDosColumnasComponent, FilaTresColumnasComponent, FilaCuatroColumnasComponent, DosColumnasMultifilasComponent, BloqueUltimosBlogsComponent, BloquePatrocinadosComponent],
})
export class EstructuraSeccionComponent implements OnInit {
  @Input() videosDirecto;
  @Input() constantesGlobales;
  @Input() publicidadCabecera;
  @Input() publicidadTop;
  @Input() publicidadBloques;
  @Input() publicidadDivisoresMovil;
  estructuraNoticias = [];
  noticiasFijadas = [];
  numTotalBloques: number;
  countNoticias: number;
  countBloques: number;
  numTotalDivisores = 3;
  countUnaColumna: number;
  countDivisor: number;

  constructor(private noticiasService: NoticiasService) {}
  ngOnInit(): void {
    const newsStructure = this.noticiasService.getEstructuraNoticiasBySeccion(this.constantesGlobales.idAmbito);
    if (newsStructure) {
      newsStructure.pipe(first()).subscribe((result) => {
        this.estructuraNoticias = result;
        this.numTotalBloques = result.length;
        this.estructuraNoticias?.forEach((item) => {
          const sectionNews = this.noticiasService.getNoticiasSeccion(item.id_seccion, 50, "subcanal", null);
          if (sectionNews) {
            sectionNews.pipe(first()).subscribe((resultSeccion) => {
              this.noticiasFijadas[item.id_seccion] = resultSeccion;
            });
          }
        });
      });
    }
  }
  getExtraClass(bloque): string {
    switch (bloque) {
      case "fila-una-columna":
        return "columns-1";
      case "fila-dos-columnas":
        return "columns-2";
      case "fila-tres-columnas":
        return "columns-3";
      case "fila-cuatro-columnas":
        return "columns-4";
      case "dos-columnas-multifilas":
        return "columns-2";
      default:
        return "";
    }
  }
  incrementarContador(count): void {
    this.countNoticias = this.countNoticias + count * 1;
  }

  incrementarContadorBloques(): void {
    this.countBloques = this.countBloques + 1;
  }

  incrementarContadorUnaColumna(): void {
    this.countUnaColumna = this.countUnaColumna + 1;
  }

  incrementarContadorDivisor(): void {
    this.countDivisor = this.countDivisor + 1;
  }

  iniciarContador(init): void {
    this.countNoticias = init * 1;
  }

  iniciarContadorBloques(init): void {
    this.countBloques = init * 1;
  }

  iniciarContadorUnaColumna(init): void {
    this.countUnaColumna = init * 1;
  }

  iniciarContadorDivisor(init): void {
    this.countDivisor = init * 1;
  }

  getNoticiasSeccion(idSeccion: any): any {
    return this.noticiasFijadas[idSeccion];
  }
}
